import { ReactNode } from 'react'
import classNames from 'classnames'
import EventCard from '@/app/_components/EventCard/EventCard'
import { useRelatedEvents } from '@/app/_providers/EventProvider/EventProvider'
import { useSeller } from '@/app/_providers/SellerProvider/SellerProvider'
import styles from '@/app/_components/EventDetails/EventDetails.module.css'
import eventListStyles from '@/app/_components/EventsList/EventsList.module.css'
import TXT from '@/messages'

const RelatedEvents = (): ReactNode => {
  const { isPreview } = useSeller()
  const relatedEventsData = useRelatedEvents()

  const displayEvents = !isPreview
    && relatedEventsData
    && !relatedEventsData.every((el) => el === null)

  if (!displayEvents) return null

  return (
    <>
      <section
        className={styles.RelatedEvents}
        data-testid="related-events"
      >
        <h1 className={styles.RelatedEventsHeader}>
          {TXT.eventsPage.relatedEvents}
        </h1>
        <div
          className={classNames(
            eventListStyles.EventCardList,
            eventListStyles.SingleColumn,
          )}
        >
          {relatedEventsData
            .map((el) => (
              <EventCard
                key={el.id}
                event={el}
              />
            ))}
        </div>
      </section>
    </>
  )
}

export default RelatedEvents
